import classNames from 'classnames/bind';
import styles from './FormStatus.module.scss';

let cx = classNames.bind(styles);

const standardErrorMessage = 'Can not complete your request at this time. Please try again at a later time.';

export function FormStatus({ id, errors, isError, isSuccess, successMessage }) {
	const errorArray = errors?.root && Object.keys(errors.root).map((key) => ({ type: key, message: errors.root[key].message }));

  function Error({type, message}) {
    if (!message) return;
    if (type === 'serverError') {
      return <p>{standardErrorMessage}</p>;
    } else {
      return <p>{message}</p>;
    }
  }

	return (
		<div role="alert" id={`${id}-help`} className={cx(['ns_form-status', 'form-status',  isError && 'form-error', isSuccess && 'form-success', (isError || isSuccess) && 'show-status'])}>
			{errorArray && errorArray.map((error, index) => <Error key={index} type={error.type} message={error.message} />)}
			{isSuccess && <p>{successMessage}</p>}
		</div>
	);
}
